import { TitleColor } from '..';
import Text from '../Text';

const Education2015 = () => (
  <>
    <TitleColor text="Kurser 2015" smallTitle />
    <Text>
      <b>Ádám Miklósi</b>
      <br />
      Weekendkursus den 17.-18. oktober 2015, omhandlende: ”The Family Dog Project”
      <br />
      Miklósi er medstifter af ”The Family Dog Project” i Budapest, Ungarn. Projektet har til formål
      at undersøge det evolutionære og etologiske fundament for hund-menneske relationen. Interessen
      ligger ikke kun i at undersøge hundens mentale formåen, men i alle aspekter af hundes og
      menneskers adfærd der har styrket båndet mellem de to arter.
    </Text>
  </>
);

export default Education2015;
